import React, { useEffect, useState } from "react";
import { Card, Col, Row, Dropdown } from 'react-bootstrap';
import { useParams, useSearchParams, useNavigate } from "react-router-dom";
import CssLoader from '../../components/cssloader/CssLoader';
import Link from "../../common/Link";
import Pagination from "../../common/Pagination";
import Sidebar from "../../components/Sidebar";
import {IMatchesPerGirone, ITeamData} from "../../helpers/interfaces/matchData";
import { ICategoryArticle } from "../../helpers/interfaces/ranking";
import { matchesService } from "../../services/MatchesService";
import Advertising from "../../common/Advertising";
import './Societa.css';
import '../PartiteOdierne/PartiteOdierne.css'
import PageMeta from "../../components/PageMeta";
import {CalendarIcon} from "../../components/Icons";
import SelectSeason from "../../common/SelectSeason";
import {matchesColumns, matchesMobileColumns} from "../../config/Tables/matchSocietà";
import Table from "../../common/Table";

export default function SocietaPage() {
    const { id } = useParams<{ id: string }>();
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const season = searchParams.get("season");
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [teamData, setTeamData] = useState<ITeamData | null>(null);
    const [teamArticles, setTeamArticles] = useState<ICategoryArticle[]>([]);
    const [teamMatches, setTeamMatches] = useState<IMatchesPerGirone[]>([]);
    const [currentPage, setCurrentPage] = useState<number>(1);
    const [isShown, setIsShown] = useState<boolean>(false);
    const [currentSeason, setCurrentSeason] = useState<string>("");
    const [years, setYears] = useState<string[]>([]);    const pageLimit = 8;
    const pageNeighbours = 5;

    useEffect(() => {
        const fetchTeamData = async () => {
            try {
                const data = await matchesService.getTeamData(id!);
                if (data && typeof data !== "string" && data.id) {
                    setTeamData(data);
                }
            } catch (error) {
                console.error("Error fetching team data: ", error);
            }
        }

        const fetchArticles = async (teamId: string) => {
            try {
                const data = await matchesService.getTeamNews(teamId);

                if (data && typeof data !== "string") {
                    setTeamArticles(data);
                }
            } catch (error) {
                console.error("Error fetching team articles: ", error);
            }
        };

        if (id) {
            (async() => {
                setIsLoading(true);

                await fetchTeamData();
                await fetchArticles(id);
                if (season) {
                    //const normalizedSeason = season.replace("-", "/");
                    setCurrentSeason(season);
                    await fetchMatches(id, season);
                } else {
                    await fetchMatches(id, currentSeason);
                }

                setIsLoading(false);
            })();
        }
    }, [id]);

    const fetchMatches = async (teamId: string, currentSeason: string) => {
        try {
            const data = await matchesService.getTeamMatches(teamId, currentSeason);

            if (data && typeof data !== "string") {
                setYears(data.anniRiferimento)
                setTeamMatches(data.partite);
                const hash = window.location.hash.replace("#", "");
                const element = document.getElementById(hash);
                if (element) {
                    element.scrollIntoView({behavior: "smooth"});
                }
                if (currentSeason === "") {
                    setCurrentSeason(data.anniRiferimento[0]);
                }
            }
        } catch (error) {
            console.error("Error fetching team matches: ", error);
        }
    };

    const handleSeasonChange = async(value: any) => {
        setCurrentSeason(value)
        navigate(`/societa/${id}?season=${value}`);

        setIsLoading(true);
        if (id) {
            await fetchMatches(id, value)
        }
        setIsLoading(false)
    }

    const paginationCards = teamArticles.slice((currentPage - 1) * pageLimit, currentPage * pageLimit);

    return (
        <React.Fragment>
            <PageMeta
                title={`${teamData?.nome} - Calcio a 5 Live`}
                description=""
                image=""
                url={document.location.href}
                type=""
            />
            <div className="contact-tag">{teamData?.nome}</div>
            <Row>
                <Col id="content" xs={12} lg={9}>
                    <div className="team-header">
                        <img src={teamData?.img || 'https://www.calcioa5live.com/img/squadre/VARIE.png'} alt="Team Logo1" className="team-logo" />
                    </div>
                    {teamData && (
                        (() => {
                            const sponsorList = [
                                {
                                    img: teamData.sponsor1Img,
                                    url: teamData.sponsor1Url,
                                },
                                {
                                    img: teamData.sponsor2Img,
                                    url: teamData.sponsor2Url,
                                },
                                {
                                    img: teamData.sponsor3Img,
                                    url: teamData.sponsor3Url,
                                },
                                {
                                    img: teamData.sponsor4Img,
                                    url: teamData.sponsor4Url,
                                },
                                {
                                    img: teamData.sponsor5Img,
                                    url: teamData.sponsor5Url,
                                },
                                {
                                    img: teamData.sponsor6Img,
                                    url: teamData.sponsor6Url,
                                },
                            ];

                            const hasAtLeastOneImage = sponsorList.some(
                                (s) => s.img && s.img.trim() !== ""
                            );

                            return hasAtLeastOneImage ? (
                                <div className="team-sponsors">
                                    <h2>Sponsor</h2>
                                    <hr />
                                    <div className="sponsor-logos d-flex flex-wrap">
                                        {sponsorList.map((s, index) =>
                                            s.img && s.img.trim() !== "" ? (
                                                <a
                                                    key={index}
                                                    href={s.url && s.url.trim() !== "" ? s.url : "#"}
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                    className="me-2 mb-2 d-inline-block"
                                                >
                                                    <img
                                                        src={s.img}
                                                        alt={`Sponsor ${index + 1}`}
                                                    />
                                                </a>
                                            ) : null
                                        )}
                                    </div>
                                </div>
                            ) : null;
                        })()
                    )}

                    {/* <div className="team-players">
                        <h2>Giocatori</h2>
                        {paginationPlayers.map((player, index) => (
                            <Card key={`player_${index}`} className="mb-3">
                                <Card.Body>
                                    <Card.Title>{player.nome} {player.cognome}</Card.Title>
                                    <Card.Subtitle className="mb-2 text-muted">{player.ruolo}</Card.Subtitle>
                                    <Card.Text>
                                        Data di Nascita: {player.dataDiNascita || 'N/A'}
                                    </Card.Text>
                                </Card.Body>
                            </Card>
                        ))}
                        <Pagination
                            totalRecords={teamData?.giocatori.length || 0}
                            pageLimit={pageLimit}
                            pageNeighbours={pageNeighbours}
                            currentPage={currentPage}
                            onPageChanged={(value: any) => { setCurrentPage(value) }}
                        />
                    </div> */}
                    <Advertising code="banner-cat4" as="div" />
                    <div className="team-matches" id="tab_matches_categories">
                        <div className="tab-content-mobile tab-content">
                            <hr />
                            <div className="row" style={{alignItems: "center"}}>
                                <div className="order-md-2 col-md-2 col-12">
                                    <Dropdown id="calendarDropdown" show={isShown} onToggle={(isOpen, _metadata) => setIsShown(isOpen)} className='calendarDropdown position-absolute'>
                                        {
                                            !isShown ?
                                                <>
                                                    <Dropdown.Toggle as="div" className="calendar-toggle" id="date-dropdown">
                                                        <span className="calendar-tag me-2">{currentSeason}</span>
                                                        <CalendarIcon />
                                                    </Dropdown.Toggle>
                                                </>
                                                : <button className="close-btn" onClick={() => setIsShown(false)}>×</button>
                                        }
                                        <Dropdown.Menu className="dropdown-menu p-0">
                                            <div className="calendar-dropdown">
                                                <SelectSeason
                                                    seasons={years}
                                                    onSeasonChange={handleSeasonChange}
                                                    currentSeason={currentSeason}
                                                />
                                            </div>
                                        </Dropdown.Menu>
                                    </Dropdown>
                                </div>
                                <div className="order-md-1 col-md-10 col-12">
                                    <h4>Lista partite di {teamData?.nome}</h4>
                                </div>
                            </div>
                            <hr />
                            <div className="mt-3">
                                {
                                    teamMatches && teamMatches.length ? teamMatches.map((
                                        girone: IMatchesPerGirone,
                                        index: number
                                    ) => {
                                        return <div className="matches_table_group fs-6" key={index}>
                                            {girone.partite && girone.partite.length > 0
                                                ? <><h3 className="text-center mt-3 group-title display-6 display-lg-4">{girone.categoria} - {girone.girone}</h3>
                                                    <Table
                                                    id={`tab_matches_categories_table_${index}_${girone.girone}`}
                                                    columns={[...matchesColumns.slice(0, -1)]}
                                                    columnsMobile={[...matchesMobileColumns.slice(0, -1)]}
                                                    data={girone.partite}
                                                    emptyDataText="Nessuna partita odierna presente"
                                                />
                                                    <hr /></> : <Row className="pb-3 d-flex justify-content-center">
                                                    Nessuna partita presente
                                                </Row>
                                            }
                                        </div>
                                    }) : <Row className="pb-3 d-flex justify-content-center">
                                        Nessuna partita presente
                                    </Row>
                                }
                            </div>
                        </div>
                    </div>
                    <div className="team-articles">
                        <hr />
                        <Advertising code="banner-cat4" as="div" />
                        <h2 className="mt-2 mb-4">Ultimi articoli sulla società</h2>
                        {paginationCards.map((article, index) => (
                            <Card key={article.id}>
                                {index % 4 === 0 && index !== 0 && (
                                    <Advertising code="banner-cat5" as="div" />
                                )}
                                <Card.Body className="px-2">
                                    <Link href={`/articolo/${article.id}`} title={article.titolo}>
                                        <Row key={article.id}>
                                            <Col className="team-img-container my-auto">
                                                <img src={article.img1 || "https://www.calcioa5live.com/images/noImg.jpg"} className="team-img" alt={article.titolo} />
                                            </Col>
                                            <Col md={8}>
                                                <Card.Title><strong>{article.titolo}</strong></Card.Title>
                                                <Card.Subtitle>{article.strDataPubblicazione} - <span className="author-name">{article.nomeAutore}</span></Card.Subtitle>
                                                <div className="card-text" dangerouslySetInnerHTML={{ __html: article.articolo }} />
                                            </Col>
                                        </Row>
                                    </Link>
                                </Card.Body>
                            </Card>
                        ))}
                        <Pagination
                            totalRecords={teamArticles.length}
                            pageLimit={pageLimit}
                            pageNeighbours={pageNeighbours}
                            currentPage={currentPage}
                            onPageChanged={(value: any) => { setCurrentPage(value) }}
                        />
                    </div>
                </Col>
                <Col id="sidebar" xs={12} lg={3} className="pt-3">
                    <Sidebar />
                </Col>
            </Row>

            <CssLoader active={isLoading} text="Caricamento della società in corso..." />
        </React.Fragment>
    );
}
